module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-message-box-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "msgbox-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "el-message-box"
  }, [(_vm.title !== '') ? _c('div', {
    staticClass: "el-message-box-header"
  }, [_c('div', {
    staticClass: "el-message-box-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.showClose) ? _c('i', {
    staticClass: "el-message-box-close el-icon-close",
    on: {
      "click": function($event) {
        _vm.handleAction('cancel')
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.message !== '') ? _c('div', {
    staticClass: "el-message-box-content"
  }, [_c('div', {
    staticClass: "el-message-box-status",
    class: [_vm.typeClass]
  }), _vm._v(" "), _c('div', {
    staticClass: "el-message-box-message",
    style: ({
      'margin-left': _vm.typeClass ? '50px' : '0'
    })
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInput),
      expression: "showInput"
    }],
    staticClass: "el-message-box-input"
  }, [_c('i-input', {
    ref: "input",
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-message-box-errormsg",
    style: ({
      visibility: !!_vm.editorErrorMessage ? 'visible' : 'hidden'
    })
  }, [_vm._v(_vm._s(_vm.editorErrorMessage))])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-message-box-btns"
  }, [_c('i-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCancelButton),
      expression: "showCancelButton"
    }],
    class: [_vm.cancelButtonClasses],
    nativeOn: {
      "click": function($event) {
        _vm.handleAction('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonText))]), _vm._v(" "), _c('i-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmButton),
      expression: "showConfirmButton"
    }],
    class: [_vm.confirmButtonClasses],
    nativeOn: {
      "click": function($event) {
        _vm.handleAction('confirm')
      }
    }
  }, [_vm._v(_vm._s(_vm.confirmButtonText))])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8ed801f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/message-box/src/main.vue
// module id = 666
// module chunks = 0